<template>
  <div>
    <b-row>
      <b-col cols="9" class="mb-2"></b-col>

      <b-col class="mb-2">
        <b-button block variant="success" @click="add()" :disabled="!CREATE"
          >Crear</b-button
        >
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="3">
        <b-form-group>
          <label for="txtNumeroFiltro">Número juzagdo</label>
          <b-form-input
            type="text"
            id="txtNumeroFiltro"
            v-model="filter.number"
            maxlength="20"
            @blur="getData()"
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group>
          <label for="cmbDepartamentoFiltro">Departamento</label>
          <b-form-select
            v-model="filter.zone_id"
            id="cmbDepartamentoFiltro"
            @change="getCitiesByZone(filter.zone_id, true)"
          >
            <template slot="first">
              <option :value="null">
                -- Por favor seleccione una opción --
              </option>
            </template>

            <option
              v-for="item in lstDepartamento"
              :key="item.id"
              :value="item.id"
            >
              {{ item.name }}
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>

      <b-col>
        <b-form-group>
          <label for="cmbCiudadFiltro">Ciudad</label>
          <b-form-select
            v-model="filter.city_id"
            id="cmbCiudadFiltro"
            @change="getData()"
          >
            <template slot="first">
              <option :value="null">
                -- Por favor seleccione una opción --
              </option>
            </template>

            <option v-for="item in lstCiudad" :key="item.id" :value="item.id">
              {{ item.name }}
            </option>
          </b-form-select>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row class="mt-0">
      <b-col cols="12" xl="12">
        <transition name="slide">
          <b-card :header="caption">
            <b-table
              :hover="hover"
              :striped="striped"
              :bordered="bordered"
              :small="small"
              :fixed="fixed"
              responsive="sm"
              :items="items"
              :fields="fields"
              :current-page="currentPage"
              :per-page="perPage"
            >
              <template slot="actions" slot-scope="data">
              <!-- <template v-slot:cell(actions)="data"> -->
                <b-button
                  size="sm"
                  variant="primary"
                  class="mr-1 btn-custom-size"
                  @click="view(data.item)"
                  :disabled="!READ"
                  title="Ver"
                >
                  <i class="fa fa-eye"></i>
                </b-button>

                <b-button
                  size="sm"
                  variant="success"
                  class="mr-1 btn-custom-size"
                  @click="edit(data.item)"
                  :disabled="!UPDATE"
                  title="Editar"
                >
                  <i class="fa fa-edit"></i>
                </b-button>
                <b-button
                  size="sm"
                  variant="danger"
                  class="btn-custom-size"
                  @click="deleteItem(data.item.id)"
                  :disabled="!DELETE"
                  title="Eliminar"
                >
                  <i class="fa fa-trash"></i>
                </b-button>
              </template>
            </b-table>
            <hr />
            <div class="row">
              <div class="col-sm-4">
                Mostrando
                {{
                  getRowCount(items) > perPage * currentPage
                    ? perPage * currentPage
                    : getRowCount(items)
                }}
                de {{ getRowCount(items) }} registros
              </div>
              <div class="col-sm-8">
                <nav>
                  <b-pagination
                    size="sm"
                    align="right"
                    :total-rows="getRowCount(items)"
                    :per-page="perPage"
                    v-model="currentPage"
                    prev-text="Anterior"
                    next-text="Siguiente"
                    :limit="10"
                  />
                </nav>
              </div>
            </div>
          </b-card>
        </transition>
      </b-col>
    </b-row>

    <!-- MODAL PARA LOS JUZGADOS -->
    <div class="modal fade" id="dlgJuzgado">
      <div class="modal-dialog modal-dialog-centered modal-success">
        <div class="modal-content">
          <!-- Modal Header -->
          <div class="modal-header">
            <h4 class="modal-title">JUZGADO</h4>
            <button type="button" class="close" @click="close()">
              &times;
            </button>
          </div>

          <!-- Modal body -->
          <div class="modal-body">
            <form @submit.prevent="save" method="post">
              <b-row>
                <b-col class="center-block">
                  <b-row>
                    <b-col sm="12" v-if="errores.length">
                      <b-alert show variant="warning">
                        <b>ADVERTENCIAS:</b>
                        <li
                          class="ml-2"
                          v-for="(error, index) in errores"
                          :key="index"
                        >
                          {{ error }}
                        </li>
                      </b-alert>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col sm="4">
                      <b-form-group>
                        <label for="txtNumero">Número juzagdo</label>
                        <b-form-input
                          type="text"
                          id="txtNumero"
                          v-model="form.number"
                          :disabled="disabled"
                          maxlength="20"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>

                    <b-col>
                      <b-form-group>
                        <label for="txtNombre">Nombre</label>
                        <b-form-input
                          type="text"
                          id="txtNombre"
                          v-model="form.name"
                          :disabled="disabled"
                        ></b-form-input>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col sm="6">
                      <b-form-group>
                        <label for="cmbDepartamento">Departamento</label>
                        <b-form-select
                          v-model="form.zone_id"
                          id="cmbDepartamento"
                          :disabled="disabled"
                          @change="getCitiesByZone(form.zone_id)"
                        >
                          <template slot="first">
                            <option :value="null" disabled>
                              -- Por favor seleccione una opción --
                            </option>
                          </template>

                          <option
                            v-for="item in lstDepartamento"
                            :key="item.id"
                            :value="item.id"
                          >
                            {{ item.name }}
                          </option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>

                    <b-col sm="6">
                      <b-form-group>
                        <label for="cmbCiudad">Ciudad</label>
                        <b-form-select
                          v-model="form.city_id"
                          id="cmbCiudad"
                          :disabled="disabled"
                        >
                          <template slot="first">
                            <option :value="null" disabled>
                              -- Por favor seleccione una opción --
                            </option>
                          </template>

                          <option
                            v-for="item in lstCiudad"
                            :key="item.id"
                            :value="item.id"
                          >
                            {{ item.name }}
                          </option>
                        </b-form-select>
                      </b-form-group>
                    </b-col>
                  </b-row>

                  <b-row v-if="!disabled" class="mt-2">
                    <b-col sm="4" class="center-block">
                      <b-button
                        type="submit"
                        variant="success"
                        class="btn-sm col-sm-12"
                        :disabled="disabled"
                        >Guardar</b-button
                      >
                    </b-col>
                  </b-row>
                </b-col>
              </b-row>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- FIN MODAL PARA LOS JUZGADOS -->
  </div>
</template>

<script>
export default {
  name: "judgeds",
  props: {
    caption: {
      type: String,
      default: "Juzgados",
    },
    hover: {
      type: Boolean,
      default: true,
    },
    striped: {
      type: Boolean,
      default: true,
    },
    bordered: {
      type: Boolean,
      default: false,
    },
    small: {
      type: Boolean,
      default: true,
    },
    fixed: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      token: localStorage.getItem("token"),
      items: [],
      fields: [
        { key: "id", label: "#" },
        { key: "number", label: "Número" },
        { key: "name", label: "Nombre" },
        { key: "zone_name", label: "Departamento" },
        { key: "city_name", label: "Ciudad" },
        { key: "actions", label: "Opciones" },
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      successModal: false,
      filter: { number: null, zone_id: null, city_id: null },

      //
      form: {},
      errores: [],
      //NUEVO
      lstDepartamento: [],
      lstCiudad: [],
      isEdit: false,
      disabled: false,
      // ------------------------------------------------------------------------
      // VARIABLES PARA LA GESTÓN DE LAS ACCIONES Y PERMISOS DE CADA USUARIO
      // ------------------------------------------------------------------------
      CREATE: false,
      READ: false,
      UPDATE: false,
      DELETE: false,
    };
  },
  mounted() {
    this.enabledActions();
    this.getData();
    this.initParameters();
  },
  computed: {},
  methods: {
    enabledActions() {
      var auth = localStorage.getItem("auth");
      auth = JSON.parse(auth)[0];
      this.CREATE = auth.create == 1;
      this.READ = auth.read == 1;
      this.UPDATE = auth.update == 1;
      this.DELETE = auth.delete == 1;
    },
    getData() {
      showLoader();
      this.filter.number =  this.filter.number == "" ? null : this.filter.number;

      this.$http
        .get(
          `${this.$urlApi}judgeds/number/${this.filter.number}/zone_id/${this.filter.zone_id}/city_id/${this.filter.city_id}?token=${this.token}`
        )
        .then(
          (response) => {
            this.items = response.data.data;
            // console.log(response);
            hideLoader();
          },
          (error) => {
            console.log(error);
            hideLoader();
          }
        );
    },
    getRowCount(items) {
      return items.length;
    },
    initParameters() {
      this.form = { name: null, number: null, zone_id: null, city_id: null };
      //DEPARTAMENTOS DE COLOMBIA
      this.$http.get(`${this.$urlApi}zones/1?token=${this.token}`).then(
        (response) => {
          this.lstDepartamento = response.data.data;
        },
        (error) => {
          console.log(error);
        }
      );
    },

    getCitiesByZone(zone_id, search = false) {
      if (zone_id) {
        showLoader();
        this.$http
          .get(`${this.$urlApi}cities/${zone_id}?token=${this.token}`)
          .then(
            (response) => {
              this.lstCiudad = response.data.data;
              if (this.form.id == null) this.form.city_id = null;
              hideLoader();
            },
            (error) => {
              console.log(error);
              hideLoader();
            }
          );
      }

      if(search) {
        this.filter.city_id = null;
        this.getData();
      }
    },

    add() {
      showLoader();
      this.initParameters();
      this.errores = [];
      $("#dlgJuzgado").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL
      this.isEdit = false;
      this.file = null;
      hideLoader();
    },
    edit(item) {
      showLoader();
      this.initParameters();
      this.errores = [];
      $("#dlgJuzgado").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL
      this.form = Object.assign({}, item);
      this.getCitiesByZone(this.form.zone_id);
      this.isEdit = true;
      $("#dlgJuzgado").modal("show");
      // hideLoader();
    },
    deleteItem(id) {
      if (id == 1) {
        this.$swal({
          title: "Información",
          text: "No se debe eliminar este registro!",
          type: "info",
          showCancelButton: false,
          confirmButtonText: "Aceptar",
        });
      } else {
        this.$swal({
          title: "Eliminar",
          text: "Desea eliminar el registro!",
          type: "warning",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonText: "Aceptar",
        }).then((result) => {
          if (result.value) {
            showLoader();
            this.$http
              .delete(`${this.$urlApi}judgeds/${id}?token=${this.token}`, {
                headers: { "Content-Type": "application/json" },
              })
              .then(function (response) {
                hideLoader();

                this.$swal({
                  title: "Buen trabajo",
                  text: "Registro eliminado correctamente!",
                  type: "success",
                  showCancelButton: false,
                  confirmButtonText: "Aceptar",
                }).then((result) => {
                  if (result.value) {
                    this.getData();
                  }
                });
              })
              .catch((error) => {
                console.log(error);
                hideLoader();
              });
          }
        });
      }
    },
    view(item) {
      showLoader();
      this.initParameters();
      $("#dlgJuzgado").modal({ backdrop: "static", keyboard: false }); // EVITA QUE SE CIERRE EL MODAL AL DAR CLIC FUERA DE EL
      this.form = Object.assign({}, item);
      this.getCitiesByZone(this.form.zone_id);
      this.disabled = true;
      $("#dlgJuzgado").modal("show");
      // hideLoader();
    },
    save() {
      if (this.isEdit) {
        this.update();
      } else {
        this.create();
      }
    },
    create() {
      showLoader();
      let datos = JSON.stringify(this.form);
      console.log(this.form);
      this.$http
        .post(`${this.$urlApi}judgeds?token=${this.token}`, datos, {
          headers: { "Content-Type": "application/json" },
        })
        .then(function (response) {
          console.log(response);
          hideLoader();
          this.$swal({
            title: "Buen trabajo",
            text: "Registro guardado correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          }).then((result) => {
            if (result.value) {
              this.getData();
              $("#dlgJuzgado").modal("hide");
            }
          });
        })
        .catch((error) => {
          this.errores = getMsgError(error);
          console.log(error);
          hideLoader();
        });
    },
    update() {
      showLoader();
      let id = this.form.id;
      let datos = JSON.stringify(this.form);
      console.log(this.form);
      this.$http
        .put(`${this.$urlApi}judgeds/${id}?token=${this.token}`, datos, {
          headers: { "Content-Type": "application/json" },
        })
        .then(function (response) {
          console.log(response);
          hideLoader();

          this.$swal({
            title: "Buen trabajo",
            text: "Registro actualizado correctamente!",
            type: "success",
            showCancelButton: false,
            confirmButtonText: "Aceptar",
          }).then((result) => {
            if (result.value) {
              this.getData();
              $("#dlgJuzgado").modal("hide");
            }
          });
        })
        .catch((error) => {
          this.errores = getMsgError(error);
          hideLoader();
        });
    },
    close() {
      this.isEdit = false;
      this.disabled = false;
      $("#dlgJuzgado").modal("hide");
    },
  },
};
</script>
